import EventsLayout from '@/components/layouts/EventLayout'
import { PageHeader } from '@/components/patterns'
import { usePage, router } from '@inertiajs/react'
import AutomatedEmailForm, {
  automatedEmailIndexPath,
  type AutomatedEmailFormProps,
} from '../components/AutomatedEmailForm'
import { getAutomatedEmailTitle } from '../types'

type PageProps = AutomatedEmailFormProps

/**
 * Standalone page for editing one automated email. The page owns only the
 * chrome — the form itself is shared with the certificate builder's Email
 * Content tab, which hosts the same component without this layout.
 */
const AutomatedEmailEdit = () => {
  const props = usePage<PageProps>().props
  const { event, automatedEmail } = props

  return (
    <EventsLayout>
      <PageHeader
        title={getAutomatedEmailTitle(automatedEmail)}
        breadcrumb={[
          {
            title: 'Email Blast',
            href: `/events/${event?.slug}/messaging/email_blasts`,
          },
          { title: 'Automated Email' },
        ]}
        showBackButton
        onBack={() => router.visit(automatedEmailIndexPath(event?.slug))}
      />

      <AutomatedEmailForm {...props} />
    </EventsLayout>
  )
}

export default AutomatedEmailEdit
